<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Summary" title="default" />

  <div class="container-fluid p-0">
    <div class="row widget-grid ">

      <div class="px-2">
      <FilterS2
        :periodNameProp="'Current MP'"
        @filterHandle="filterHandle" 
        />
      </div>

      <el-row class="m-0 width-100-p mt-3 ">
        <el-col class="d-flex align-item-center px-2" :span="24">
          <div class="row m-0 width-100-p">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
            <el-col 
                    :span="24" 
                    :class="'mb-2'"
                    >
                    <el-row>
                      <el-col :span="12">
                        <el-text tag="sub" size="small" class="text-white">
                        <span class="text-white">* Please refresh this table manually to see the latest data for this monitoring period</span><br>
                        <span class="text-white">Last Update : {{ lastUpdateSummary }}</span>
                      </el-text>
                      </el-col>
                      <el-col :span="12" class="x-end">
                        <el-button
                            color="#ddf0ac"
                            @click="refreshData"
                            class="height-40 rounded-3 width-100 pr-3"
                          >
                            <svg class="stroke-icon width-20 height-20">
                              <use
                                href="@/assets/svg/icon-sprite.svg#stroke-refresh"
                              ></use>
                            </svg>
                            <span class="moderat-btn-apply pl-2"> Refresh </span>
                          </el-button>
                      </el-col>
                    </el-row>
                    </el-col>
              <el-col :span="24">
                <div class="row m-0">
                  <el-col
                    class="pl-0"
                    :span="$vuetify.display.width >= 450 ? 14 : 24"
                    :class="
                      $vuetify.display.width < 450
                        ? 'x-center p-0 order-3 mt-2'
                        : ''
                    "
                  >
                    <!-- <el-input
                      size="large"
                      v-model="search"
                      placeholder="Type to search by customer name"
                      :prefix-icon="Search"
                      class="table-search"
                    /> -->

                      <el-input
                        size="large"
                        v-model="search"
                        placeholder="Type to search by customer name"
                        :prefix-icon="Search"
                        class="mixedSearchBar-2"
                        id="mixedSearchBar-input-2"
                        clearable
                        @clear="handleReload"
                      >
                        <template #append>
                          <el-button
                          @click.stop="handleReload"
                          class="newSearchButtonClass"
                        >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                        </template>
                      </el-input>

                  </el-col>
                  <el-col
                    class="p-0"
                    :span="$vuetify.display.width >= 450 ? 10 : 24"
                    :class="
                      $vuetify.display.width < 450
                        ? 'x-center pr-1 order-1 width-100-p'
                        : 'd-flex justify-content-end'
                    "
                  >
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
                  </el-col>
                </div>
              </el-col>
              <DataTable
                :dataProp="dataList"
                :loadingProp="loading"
                :totalRowProp="total_items"
                @tableAction="handleTableAction"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>


  </div>

 

</template>

<script>
import UserService from "../../../services/user.service";
import DataTable from "./dataTable.vue";
import {exportToExcel} from "../common/exportExcel.js";

import FilterS2 from "../common/filter-s2.vue";


export default {
  props: {},
  components: {
    DataTable,
    FilterS2,
  },
  watch: {},
  computed: {
    stateList() {
      return this.states;
    },
  },
  data() {
    return {
      lastUpdateSummary: "",
      current_page: 1,
      perPageCount: 50,
      total_items: 100,
      search: "",
      dataList: [],
      loading: false,
      stateFilter: null,
      filter: {
        customer_id: null,
        startDate: "2023-01-01",
        endDate: "2023-12-31",
      },
    };
  },
  mounted() {
    // this.fetchData();
  },
  methods: {
    fetchData() {
      let mp_id = this.filter.mp_id;
      let body = {};
      if (mp_id != null && mp_id !== "") {
        body.mp_id = mp_id;
        body.search = this.search;
      } else {
        body.customer_id = this.filter.customer_id;
        body.start_time = this.filter.startDate;
        body.end_time = this.filter.endDate;
        body.mp_id = null;
        body.search = this.search;
      }
      this.loading = true;
      UserService.GetAllInOne(body, this.current_page, this.perPageCount)
        .then(
          (response) => {
            this.dataList = response.data.data;
            this.total_items = response.data.total_record;
            this.lastUpdateSummary = response.data.updated_at.replace("T", " ");
          },
          (error) => {
            this.loading = false;
            console.log(error);
            this.lastUpdateSummary = "";
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    async refreshData() {
      let body = {};
      if (this.filter.mp_id != null && this.filter.mp_id !== "") {
        body.mp_id = this.filter.mp_id;
      } else {
        this.$message.error("Please select a monitoring period to refresh data");
        return;
      }
      try {
        this.loading = true;
        const response = await UserService.RefreshAllInOne(body);
        this.dataList = response.data.data;
        this.total_items = response.data.total_record;
        this.lastUpdateSummary = response.data.updated_at.replace("T", " ");
      } catch (error) {
        console.log(error);
        this.$message.error("Failed to refresh data");
        this.lastUpdateSummary = "";
      }
      finally {
        this.loading = false;
      }
    },
    handleReload() {
      this.fetchData();
    },
    handleTableAction(event) {
      if (event.kind == "changePage") {
        this.current_page = event.index;
        this.handleReload();
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },
    // async handleExportFile() {
    //   this.excelDataList = this.dataList;
    //   if (this.excelDataList.length > 0) {
    //     const ws = XLSX.utils.json_to_sheet(this.excelDataList, {
    //       header: Object.keys(this.excelDataList[0]),
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "SummaryList.xlsx");
    //   }
    // },

    async handleExportFile() {
      const dataList = this.dataList; // Your data
      const skipKeys = ["customer_id", "fuel_avoided_kg"]; // Keys to skip
      const fileName = "SummaryList.xlsx"; // File name
      const newWorksheetName = "Summary"; // Worksheet name
      const title = "Summary List"; // Title for the Excel file

      // single table excel file, call create single sheet excel
      try{

      
      await exportToExcel({
        dataList,
        skipKeys,
        fileName,
        newWorksheetName,
        title,
      });
    } catch(error) {
      console.log("error when exporting excel", error.message);
    }
    },
   
    filterHandle(event) {
      this.filter = event;
      this.fetchData();
    },
  },
};
</script>

<style></style>
